<template>
  <d-card class="card-small mb-3">
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ title }}</h6>
    </d-card-header>

    <d-card-body class="px-0">
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-button class="btn-success btn-block" href="#" @click="save">Salvar</d-button>
        </d-list-group-item>

      </d-list-group>
    </d-card-body>
  </d-card>
</template>

<script>
import Events from '_utils/events';
import { _SAVE_MODEL_ } from './RatingModel';

export default {
  name: 'sidebar-actions',
  props: {
    title: {
      type: String,
      default: 'Ações',
    },
  },
  computed: {
  },
  methods: {
    save() {
      Events.$emit(_SAVE_MODEL_);
    },
  },
  mounted() {
  },
};
</script>
